import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Sales/Customer/CustomerProfile';

const ViewCustomer = () => ((orgContainer(InnerComponent)));
export default ViewCustomer;
